import classNames from 'classnames';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Field } from 'redux-form';

import AddressForm from 'common/components/address/AddressForm';
import { RadioButton } from 'common/components/forms';

import AddressPicker from './AddressPicker';

const BillAddressShipLoggedIn = (props) => {
  const {
    handleAddressChange,
    handleSaveAddress,
    object,
    changeFunction,
    isSaveAddress,
    customer
  } = props;

  const [selectedOption, setSelectedOption] = useState('shipping');

  const customerAddressReducer = useSelector((state) => state.customerAddress);
  const settingReducer = useSelector((state) => state.setting);

  const handleSameAsBilling = (e) => {
    setSelectedOption(e.currentTarget.value);
  };

  return (
    <div className="c7-checkout__content__radio-options-group">
      <Field
        name="isSameAsBillingAddress"
        component={RadioButton}
        label="Same as shipping address"
        onChange={handleSameAsBilling}
        type="radio"
        value="shipping"
      />

      <div className="c7-no-border">
        <Field
          name="isSameAsBillingAddress"
          component={RadioButton}
          label="Use a different billing address"
          onChange={handleSameAsBilling}
          type="radio"
          value="billing"
        />
      </div>

      <div
        className={classNames(
          selectedOption === 'shipping'
            ? 'c7-checkout__content__radio-options-group__hidden'
            : 'c7-checkout__content__radio-options-group__edit'
        )}
      >
        {customer && (
          <AddressPicker
            customerAddresses={customerAddressReducer.data}
            onAddressChange={handleAddressChange}
          />
        )}
        <AddressForm
          object={object}
          changeFunction={changeFunction}
          settings={settingReducer}
        />
        {customer && (
          <div>
            <label htmlFor="saveAddress">
              <input
                type="checkbox"
                name="saveAddress"
                onChange={handleSaveAddress}
                value
                checked={isSaveAddress}
              />
              Save this information
            </label>
          </div>
        )}
      </div>
    </div>
  );
};

export default BillAddressShipLoggedIn;
